import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { isOfType, PlannerProductComponent, getProductReferenceFor, ShoppingBagComponent, InteriorComponent, OuterMeasurementsComponent, HideInSeeThroughSystemComponent, AssemblyInstructionsComponent, ProductType, AdjustableComponent, AdjustableStateComponent, AdjustableClothrailLimitsComponent, AdjustableHostComponent } from '@inter-ikea-storageone/range';
export const aurdalComponentResolver = (_coreApi, _products, _unavailableProducts, _productsNotInMarket, _coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.AURDAL_SIDEPANEL,
        ProductType.AURDAL_SHELF,
        ProductType.AURDAL_DRAWER,
        ProductType.AURDAL_BASKET,
        ProductType.AURDAL_SHOERACK,
        ProductType.AURDAL_CLOTH_RAIL,
        ProductType.AURDAL_EXT_CLOTH_RAIL,
        ProductType.AURDAL_SUSPENSION_RAIL
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.AURDAL_FRAME,
        ProductType.AURDAL_SHELF,
        ProductType.AURDAL_DRAWER,
        ProductType.AURDAL_BASKET,
        ProductType.AURDAL_SHOERACK,
        ProductType.AURDAL_CLOTH_RAIL,
        ProductType.AURDAL_EXT_CLOTH_RAIL,
        ProductType.AURDAL_SUSPENSION_RAIL
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([ProductType.AURDAL_SIDEPANEL]);
    const hideInSeeThroughEntitySystem = isOfType([]);
    const isInterior = isOfType([
        ProductType.AURDAL_SHELF,
        ProductType.AURDAL_DRAWER,
        ProductType.AURDAL_BASKET,
        ProductType.AURDAL_SHOERACK,
        ProductType.AURDAL_CLOTH_RAIL
    ]);
    const isFrameAssembly = isOfType([ProductType.AURDAL_FRAME]);
    const isSidePanel = isOfType([ProductType.AURDAL_SIDEPANEL]);
    const shouldHaveAssemblyInstructions = isOfType([]);
    const isAdjustableHost = isOfType([ProductType.AURDAL_FRAME]);
    const isExtendableClothRail = isOfType([ProductType.AURDAL_EXT_CLOTH_RAIL]);
    const componentBuilder = {
        build: (entity) => {
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (shouldHaveAssemblyInstructions(entity)) {
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
            }
            if (hideInSeeThroughEntitySystem(entity)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
            }
            if (isFrameAssembly(entity)) {
                entity.addComponent(new AdjustableHostComponent());
            }
            if (isExtendableClothRail(entity)) {
                entity.addComponent(new AdjustableComponent());
                HierarchyUtils.children(entity).forEach(e => {
                    e.addComponent(new AdjustableStateComponent(e.getComponent(ComponentIds.META_DATA_COMPONENT_ID)?.metaData?.components['AdjustableStateComponent']));
                });
                const metadata = entity.getComponent(ComponentIds.META_DATA_COMPONENT_ID)
                    ?.metaData?.components['AdjustableComponent'];
                entity.addComponent(new AdjustableClothrailLimitsComponent(metadata?.minWidth, metadata?.maxWidth));
            }
            if (isAdjustableHost(entity) || isSidePanel(entity)) {
                entity.addComponent(new AdjustableHostComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=aurdalComponentResolver.js.map